//DIFFERENTS ROLES UTILISATEURS

export const ROLE_ADMIN_SOCIETE_MERE = "RoleAdminSocieteMere";
export const ROLE_ADMIN_COMPAGNIE_TRANSPORT = "RoleAdminCompagnieTransport";
export const ROLE_UTI_GARE_COMPAGNIE_TRANSPORT =
  "RoleUtiGareCompagnieTransport";
export const ROLE_UTI_SIMPLE = "RoleUtiSimple";
export const ROLE_AGENT_GARE = "RoleAgentGare";
export const ROLE_BAGAGISTE = "RoleUtiBagagiste";
